<template>
  <div class="feedbackList">
    <m-loading :loading="homeLoading" />
    <img class="feedbackList_img" src="@/assets/images/mine/bg.png" alt="">
    <div class="tabItem">
				<div class="item" v-for="(item,index) in tab" :class="{'active':item.type==activeTab}" :key="index"
					@click="tabChange(item)" :name="item.name">
					{{item.name}}
				</div>
			</div>
    <van-list v-if="newsList.length>0" v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoadFeedBack">
      <div v-slidein class="news-item" v-for="(item, i) in newsList" :key="i" @click="getFeeBack(item.feedbackType,item,item.id)">
        <div class="overallBetween item-top">
          <div>{{item.addTime}}</div>
          <div class="overallCenter" :class="item.typeId==1?'Selected':''">{{item.typeId==1?'已回复':'未回复'}}</div>
        </div>
				<div class="item-eedback" v-if="item.activityId>0">
				  <div class="AlignTop">咨询活动：</div>
				  <div class="AlignTop">{{item.activityName}}</div>
				</div>
        <div class="item-eedback">
          <div class="AlignTop">反馈内容：</div>
          <div class="AlignTop">{{item.content}}</div>
        </div>
        <!-- <div class="item-reply" v-if="item.typeId==1">
          {{item.reply}}
        </div> -->
      </div>
    </van-list>
    <div class="nullData" v-else-if="!homeLoading">
      <img class="nullData_img" src="@/assets/images/mine/quesheng.png" alt="">
      <div class="nullData_tip"></div>
    </div>
    <img v-draggable class="wentifankui-img" @click="getFeeBackReply" src="@/assets/images/mine/wentifankui.png"/>
  </div>
</template>
<script>
import { getFeeBackList } from "@/utils/api/user";
export default {
  components: {
  },
  data() {
    return {
      homeLoading:true,
      loading:false,
      finished:false,
      newsList:[],
      page:0,
			tab: [{
				name: '全部',
				type: 0
			
			}, {
				name: '活动咨询',
				type: 1
			
			}, {
				name: '平台咨询',
				type: 2
			
			}, {
				name: '投诉建议',
				type: 3
			
			}],
			activeTab: 0,
    }
  },
  async mounted() {
    this.onLoadFeedBack()
  },
  methods: {
    //
		tabChange(data) {
			console.log(data)
      this.page=0
      this.newsList = []
			this.activeTab = data.type
      this.onLoadFeedBack()
		},
		
		
    onLoadFeedBack() {
      this.loading = true;
      this.page++;
      getFeeBackList({
        pageNo: this.page,
        pageSize: 10,
        feedbackType:this.activeTab
      }).then((res) => {
        if (res.success) {
          this.newsList.push(...res.data.records);
          if (this.page * 10 >= res.data.total) this.finished = true;
          this.loading = false;
        } else {
          this.loading = false;
          this.finished = true;
        }
        this.homeLoading = false
      });
    },
    getFeeBackReply(){
      this.$router.push({
        path:'/mine/FeedbackType'
      })
    },
    getFeeBack(type,data,feedbackId){
			  this.$router.push({
					path:'/mine/Feedback',
					query:{
						type:type==0?3:type,
            feedbackId:feedbackId,
						data:JSON.stringify({
              name:data.activityName,
              id:data.activityId
            })
						
					}
				})
			},
  }
}
</script>
<style lang="scss" scoped>
	
.feedbackList{
  position: absolute;
  min-height: 100vh;
  background-color:#F9F9FA;
  width: 375px;
  padding: 0 15px;
	// background: url(../../assets/images/mine/bg.png)  no-repeat center 100%;
  .feedbackList_img{
    position: fixed;
    top: 0px;
    left: 0px;
		right: 0;
    // height: 339px;
    width: 10rem;
		margin: 0 auto;
  }
  .nullData{
    position: relative;
    margin-top: 30%;
    .nullData_img{
      width: 146px;
      height: 120px;
    }
    .nullData_tip{
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #404046;
      line-height: 18px;
    }
  }
  .news-item {
    background: #FFFFFF;
    border-radius: 8px 8px 8px 8px;
    padding:0 15px;
    margin-bottom: 15px;
    padding-bottom:1px;
    .item-top{
      height: 43px;
      width: 315px;
      border-bottom: 1px solid #F0F0F0;
      div:first-child{
        font-size: 12px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        color: #999999;
      }
      div:last-child{
        width: 53px;
        height: 22px;
        background: rgba(255,114,70,0.1);
        border-radius: 25px 25px 25px 25px;
        font-size: 12px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        color: #FF7246;
      }
      .Selected{
        background: rgba(49,208,118,0.1);
        color: #31D076;
      }
    }
    .item-eedback{
      margin-top: 17px;
      margin-bottom: 20px;
      div:first-child{
        width: 75px;
        min-width: 75px;
        font-size: 15px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        color: #999999;
      }
      div:last-child{
        width: 230px;
        max-width: 240px;
        font-size: 15px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        color: #222222;
      }
    }
  }
  .van-list{
    position: relative;
    // padding-top: 10px;
  }
  .wentifankui-img{
    position: fixed;
    right: 0px;
    bottom: 150px;
    width: 101px;
    height: 47px;
    z-index: 1000;
  }
  .item-reply{
    width: 315px;
    max-width: 315px;
    padding: 13px 9px;
    margin-bottom: 14px;
    background: #F9F9FA;
    border-radius: 8px 8px 8px 8px;
    font-size: 15px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: #666666;
    text-align: left;
  }
}


.van-sticky{
	max-width: 10rem;
	margin: 0 auto;
}
.tabItem{
	display: flex;
	padding: 15px 0px 20px 0px;
	font-weight: 500;
	font-size: 14px;
	color: #666;
	align-items: center;
	position: relative;
	
	
	.item{
		padding:0 12px;
		position: relative;
		// padding-bottom: 5px;
		
		&.active{
			font-weight: bold;
			font-size: 16px;
			color: #404046;
			position: relative;
			top:-0px;
			 // transition: all 300ms;
			&:after{
				content: '';
				display: block;
				position: absolute;
				margin-left: -10px;
				left: 50%;
				bottom: -10px;
				width: 20px;
				height: 7px;
				background:url(~@/assets/images/mine/icon_label.png)  no-repeat top center;
				background-size: 100%;
				animation: slide-in 0.5s ease forwards;
				
			}
		}
	}
	
}
</style>